import { render, staticRenderFns } from "./Novel_pack.vue?vue&type=template&id=59426e95&scoped=true&"
import script from "./Novel_pack.vue?vue&type=script&lang=js&"
export * from "./Novel_pack.vue?vue&type=script&lang=js&"
import style0 from "./Novel_pack.vue?vue&type=style&index=0&id=59426e95&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59426e95",
  null
  
)

export default component.exports